"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SkeletonWrapper = _interopRequireDefault(require("../SkeletonWrapper"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _labeling = _interopRequireDefault(require("../../containers/labeling"));
var _MyAccountUserInfoStyled = require("./MyAccountUserInfoStyled");
var MyAccountUserInfo = function MyAccountUserInfo(_ref) {
  var t = _ref.t;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.userProfile;
    }),
    user = _useSelector.user;
  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
      return state.planDetails;
    }),
    _useSelector2$current = (0, _slicedToArray2.default)(_useSelector2.currentPlan, 1),
    plan = _useSelector2$current[0];
  var isDataLoaded = !!user;
  var subscription = plan && t("offer-title-".concat(plan.offerId), plan.offerTitle);
  var isNameSet = (user === null || user === void 0 ? void 0 : user.firstName) || (user === null || user === void 0 ? void 0 : user.lastName);
  return /*#__PURE__*/_react.default.createElement(_MyAccountUserInfoStyled.WrapStyled, null, /*#__PURE__*/_react.default.createElement(_SkeletonWrapper.default, {
    showChildren: isDataLoaded,
    circle: true,
    width: 80,
    height: 80
  }, /*#__PURE__*/_react.default.createElement(_MyAccountUserInfoStyled.PhotoStyled, null)), /*#__PURE__*/_react.default.createElement(_MyAccountUserInfoStyled.DetailsStyled, {
    isEmpty: !(user !== null && user !== void 0 && user.email)
  }, /*#__PURE__*/_react.default.createElement(_SkeletonWrapper.default, {
    showChildren: isDataLoaded,
    height: 26
  }, isNameSet && /*#__PURE__*/_react.default.createElement(_MyAccountUserInfoStyled.NameStyled, null, "".concat(user === null || user === void 0 ? void 0 : user.firstName, " ").concat(user === null || user === void 0 ? void 0 : user.lastName))), /*#__PURE__*/_react.default.createElement(_SkeletonWrapper.default, {
    showChildren: isDataLoaded
  }, /*#__PURE__*/_react.default.createElement(_MyAccountUserInfoStyled.MailStyled, {
    bigger: !isNameSet
  }, user === null || user === void 0 ? void 0 : user.email)), /*#__PURE__*/_react.default.createElement(_SkeletonWrapper.default, {
    showChildren: isDataLoaded,
    height: 36,
    margin: "0"
  }, subscription && /*#__PURE__*/_react.default.createElement(_MyAccountUserInfoStyled.TextStyled, null, subscription))));
};
MyAccountUserInfo.propTypes = {
  t: _propTypes.default.func
};
MyAccountUserInfo.defaultProps = {
  t: function t(k) {
    return k;
  }
};
var _default = (0, _reactI18next.withTranslation)()((0, _labeling.default)()(MyAccountUserInfo));
exports.default = _default;